import React, { Component } from 'react'
import { compact } from 'lodash'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import HeadingBanner from 'components/Text/HeadingBanner'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import Pagination from 'components/Pagination'
import Button from 'components/Button'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import { moment } from 'features/Moment'
import { Table, TableHeader, TableRow } from 'features/Table'

import cn from 'classnames'
import sAnim from 'components/Animation/Animation.scss'
import sText from 'components/Text/Text.scss'

export default class FlowLogs extends Component {
  componentWillMount() {
    const { getFlowLogs, flowId, page, cacheKey, getFlows } = this.props
    getFlows()
    getFlowLogs({ flowId, page, cacheKey })
  }
  componentWillReceiveProps(nextProps) {
    const { getFlowLogs, flowId, page, cacheKey } = nextProps
    if (cacheKey && cacheKey !== this.props.cacheKey) {
      getFlowLogs({ flowId, page, cacheKey })
    }
  }
  render() {
    const { totalPages, results, loading, location, replace, page, flowId, flow } = this.props

    return (
      <Page layout={{ header: 'app' }} title="Flows">
        <PageHeader>
          <Crumbs title="Flows">
            <Crumb parent to="/dashboard/flows">
              Flows
            </Crumb>
            <Crumb to={`/dashboard/flows/${flowId}`}>{flow && flow.name}</Crumb>
            <Crumb to={`/dashboard/flows/${flowId}/logs`} active>
              Logs
            </Crumb>
          </Crumbs>
          <HeadingBanner>
            <h3 className={cn(sText.heading3, sText.accent)}>Flow logs</h3>
            <div className={sText.descrip1}>When and why your flow ran</div>
          </HeadingBanner>
        </PageHeader>
        <Container paddingTop paddingBottom className={cn('md', sAnim.comeUp)}>
          {results.length === 0 ? (
            <EmptyMessageCard
              loading={loading}
              title="You have no flow logs yet."
              subtitle="This will appear once your flow gets triggered."
            />
          ) : (
            <div>
              <Table
                header={
                  <TableHeader>
                    <div>Time</div>
                    <div>Contact</div>
                    <div>Events Triggered</div>
                    <div style={{ maxWidth: '76px' }} />
                  </TableHeader>
                }
              >
                {results.map(flowLog => {
                  const time = moment(flowLog.created).format('DD MMM YYYY, h:mm:ss a')
                  return (
                    <TableRow key={flowLog.id}>
                      <div title={time}>{time}</div>
                      <div>
                        {flowLog.env &&
                          flowLog.env.contact &&
                          compact(
                            [flowLog.env.contact.firstName, flowLog.env.contact.lastName].join(' ')
                          )}
                      </div>
                      <div>{flowLog.events.length}</div>
                      <div style={{ maxWidth: '76px' }}>
                        <Button
                          color="tertiary"
                          size="xs"
                          ghost
                          to={`/dashboard/flows/${flowId}/logs/${flowLog.id}`}
                        >
                          View
                        </Button>
                      </div>
                    </TableRow>
                  )
                })}
              </Table>
            </div>
          )}
          <Pagination
            page={page}
            numPages={totalPages}
            onClick={nextPage =>
              replace({
                pathname: location.pathname,
                query: {
                  page: nextPage,
                },
              })
            }
          />
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/FlowLogs/FlowLogs.jsx